module.exports = __webpack_public_path__ + "img/2258b023-29ba-433f-b909-88f542adc3b9.2b2cdb1a.webp";